/* Jing Soda storefront — add-to-cart (AJAX) + scroll reveal-on-view + card star ratings. */
(function () {
  // Several sections include this file; only the first copy may run.
  if (window.__jingStoreInit) return;
  window.__jingStoreInit = true;
  // Reliable add-to-cart: intercept the click in the CAPTURE phase (before the
  // theme's own product-form JS can swallow the submit), add via AJAX, then
  // send the buyer to the cart. Preserves variant + any injected selling_plan.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.jing-add-form [type="submit"], .jing-add-form button:not([type])');
    if (!btn) return;
    var form = btn.closest('form');
    if (!form) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (btn.disabled) return;
    btn.disabled = true;
    var label = btn.innerHTML;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return fetch('/cart.js').then(function (c) { return c.json(); });
    }).then(function (cart) {
      // Stay on the page so shoppers keep browsing: confirm on the button,
      // bump the header badge, and offer the cart via a toast.
      btn.disabled = false;
      btn.innerHTML = 'Added ✓';
      setTimeout(function () { btn.innerHTML = label; }, 1800);
      document.querySelectorAll('.jing-header__icon[aria-label="Cart"]').forEach(function (a) {
        var b = a.querySelector('.jing-header__count');
        if (!b) { b = document.createElement('span'); b.className = 'jing-header__count'; a.appendChild(b); }
        b.textContent = cart.item_count;
      });
      var t = document.querySelector('.jing-toast');
      if (!t) { t = document.createElement('div'); t.className = 'jing-toast'; document.body.appendChild(t); }
      t.innerHTML = 'Added to cart · <a href="/cart">View cart &rarr;</a>';
      t.classList.add('is-on');
      clearTimeout(t.__hide);
      t.__hide = setTimeout(function () { t.classList.remove('is-on'); }, 3500);
    }).catch(function () {
      btn.disabled = false; btn.innerHTML = label;
      var err = form.querySelector('.jing-add-err');
      if (!err) {
        err = document.createElement('p');
        err.className = 'jing-add-err';
        form.appendChild(err);
      }
      err.textContent = 'Sorry — couldn’t add to cart. Please try again.';
      setTimeout(function () { err.remove(); }, 5000);
    });
  }, true);

  function init() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var sections = document.querySelectorAll('.jing-section');
    if (!sections.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('jing-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0, rootMargin: '0px 0px 320px 0px' });

    sections.forEach(function (sec) {
      if (sec.querySelector('.jing-hero')) return; // hero shows instantly
      var targets = [sec];
      // Product grids (.jing-grid) are deliberately NOT staggered — revenue
      // content must never sit at opacity 0 while someone scrolls past it.
      sec.querySelectorAll('.jing-trust__grid, .jing-reviews__grid, .jing-testi__grid, .jing-pillars').forEach(function (g) {
        Array.prototype.slice.call(g.children, 0, 8).forEach(function (child, ci) {
          child.classList.add('jing-reveal', 'jing-d' + Math.min(3, (ci % 3) + 1));
          targets.push(child);
        });
      });
      targets.forEach(function (t) {
        if (!t.classList.contains('jing-reveal')) t.classList.add('jing-reveal');
        var r = t.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.9) t.classList.add('jing-in');
        else io.observe(t);
      });
    });

    // Safety net: never leave content permanently hidden (anchor jumps,
    // instant scrolls, or a missed IntersectionObserver callback).
    function revealAllInView() {
      document.querySelectorAll('.jing-reveal:not(.jing-in)').forEach(function (t) {
        var r = t.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) { t.classList.add('jing-in'); io.unobserve(t); }
      });
    }
    window.addEventListener('scroll', revealAllInView, { passive: true });
    setTimeout(function () {
      document.querySelectorAll('.jing-reveal:not(.jing-in)').forEach(function (t) { t.classList.add('jing-in'); });
    }, 2500);
  }
  // Card star ratings, straight from Yotpo's public bottomline API. The
  // legacy bottomLine widget showed the site-wide score on every card, so we
  // render stars ourselves from per-product data (data-jing-rating = the
  // product's own Yotpo/Shopify ID — see jing-yotpo-id). Products with no
  // reviews are left untouched: empty slots stay empty/hidden, no fake stars.
  var YOTPO_KEY = 'R0043nMFn1Y0McJmhZLIuzcrWHm1axgPD5D8Ymz7';
  function initRatings() {
    var els = document.querySelectorAll('[data-jing-rating]');
    if (!els.length) return;
    var byId = {};
    els.forEach(function (el) {
      var id = el.getAttribute('data-jing-rating');
      (byId[id] = byId[id] || []).push(el);
    });
    Object.keys(byId).forEach(function (id) {
      var paint = function (bl) {
        if (!bl || !bl.total_reviews) return;
        var pct = Math.round((bl.average_score / 5) * 100);
        byId[id].forEach(function (el) {
          el.innerHTML =
            '<span class="jing-stars-frac" aria-hidden="true">★★★★★<i style="width:' + pct + '%">★★★★★</i></span>' +
            '<span class="jing-rating-count">' + bl.average_score.toFixed(1) + ' (' + bl.total_reviews + ')</span>';
          el.setAttribute('aria-label', 'Rated ' + bl.average_score.toFixed(1) + ' out of 5 from ' + bl.total_reviews + ' reviews');
        });
      };
      var cacheKey = 'jingbl:' + id;
      try {
        var cached = JSON.parse(sessionStorage.getItem(cacheKey));
        if (cached) { paint(cached); return; }
      } catch (e) {}
      fetch('https://api.yotpo.com/products/' + YOTPO_KEY + '/' + id + '/bottomline')
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var bl = j && j.response && j.response.bottomline;
          if (!bl) return;
          try { sessionStorage.setItem(cacheKey, JSON.stringify(bl)); } catch (e) {}
          paint(bl);
        })
        .catch(function () {});
    });
  }

  // Superpower filter chips on collection pages — instant client-side show/hide.
  function initSpFilter() {
    var bar = document.querySelector('.jing-spfilter');
    if (!bar) return;
    bar.addEventListener('click', function (e) {
      var b = e.target.closest('.jing-spfilter__chip');
      if (!b) return;
      bar.querySelectorAll('.jing-spfilter__chip').forEach(function (x) { x.classList.remove('is-on'); });
      b.classList.add('is-on');
      var v = b.getAttribute('data-sp');
      document.querySelectorAll('.jing-shop .jing-card').forEach(function (c) {
        c.style.display = (!v || c.getAttribute('data-sp') === v) ? '' : 'none';
      });
    });
  }

  // Footer newsletter: mirror the signup into the store's Klaviyo account
  // (client subscriptions API — consent-based, no private key) before the
  // regular Shopify customer capture submits.
  var KLAVIYO_COMPANY = 'W4h2Ty';
  function initNewsletterKlaviyo() {
    document.querySelectorAll('.jing-footer__news').forEach(function (wrap) {
      var form = wrap.closest('form');
      var input = wrap.querySelector('input[type="email"]');
      if (!form || !input) return;
      form.addEventListener('submit', function () {
        var email = (input.value || '').trim();
        if (!email) return;
        try {
          fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY, {
            method: 'POST',
            keepalive: true,
            headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: 'Footer signup',
                  profile: { data: { type: 'profile', attributes: { email: email } } }
                },
                relationships: { list: { data: { type: 'list', id: 'RQ4F7s' } } }
              }
            })
          });
        } catch (e) {}
      });
    });
  }

  // Arrow buttons for horizontal scroll rows.
  function initScrollArrows() {
    document.querySelectorAll('.jing-scroll-wrap').forEach(function (wrap) {
      var grid = wrap.querySelector('.jing-grid--scroll');
      if (!grid) return;
      wrap.querySelectorAll('.jing-scroll-arrow').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var card = grid.firstElementChild;
          var step = card ? card.getBoundingClientRect().width + 22 : 300;
          grid.scrollBy({ left: btn.classList.contains('jing-scroll-arrow--next') ? step : -step, behavior: 'smooth' });
        });
      });
    });
  }

  // Slight scroll parallax on [data-plx] elements. Measures the untransformed
  // parent so the applied transform never feeds back into the math.
  function initParallax() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-plx]'));
    if (!els.length) return;
    var ticking = false;
    function frame() {
      ticking = false;
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var ref = el.parentElement || el;
        var r = ref.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var speed = parseFloat(el.getAttribute('data-plx')) || 0.06;
        var y = (r.top + r.height / 2 - vh / 2) * -speed;
        var t = 'translate3d(0,' + y.toFixed(1) + 'px,0)';
        if (el.hasAttribute('data-plx-scale')) t += ' scale(1.12)';
        el.style.transform = t;
      });
    }
    function queue() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue, { passive: true });
    frame();
  }

  function boot() { init(); initRatings(); initSpFilter(); initScrollArrows(); initNewsletterKlaviyo(); initParallax(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
